{
  "version": 1,
  "asset_id": "9bc7166b-7474-4657-8f2d-72273cbfea49",
  "project_id": "f9ca952a-2109-492f-a7b0-0345b2dfa2e1",
  "url": "/__l5e/assets-v1/9bc7166b-7474-4657-8f2d-72273cbfea49/danny-portrait-1.jpeg",
  "r2_key": "a/v1/f9ca952a-2109-492f-a7b0-0345b2dfa2e1/9bc7166b-7474-4657-8f2d-72273cbfea49/danny-portrait-1.jpeg",
  "original_filename": "danny-portrait-1.jpeg",
  "size": 297697,
  "content_type": "image/jpeg",
  "created_at": "2026-06-16T09:45:04Z"
}
